/* Shared "are you sure?" notice. Cream shell, dark purple header and CTA, square corners,
   same voice as the calculator's mid-quarter heads up. */
import { X } from "@phosphor-icons/react";

export const ConfirmNotice = ({
  eyebrow = 'Before you lock this in',
  title,
  lead,
  items = [],
  note,
  confirmLabel = 'Yes, lock it in',
  cancelLabel = 'Cancel',
  secondary,
  busy = false,
  onConfirm,
  onCancel,
  testId = 'confirm-notice',
  children,
}) => (
  <div
    className="fixed inset-0 z-50 flex items-center justify-center p-3 sm:p-6"
    style={{ background: 'rgba(42, 30, 92, 0.6)' }}
    data-testid={testId}
  >
    <div
      className="relative w-full max-w-2xl max-h-[94vh] overflow-y-auto"
      style={{ background: '#FAF7F0', border: '1px solid #E0D9CB', borderRadius: 0, boxShadow: '0 24px 60px rgba(42, 30, 92, 0.2)' }}
    >
      <div className="px-6 sm:px-9 py-4 flex items-center justify-between" style={{ background: '#2A1E5C' }}>
        <p className="font-body text-[11px] uppercase tracking-[0.26em]" style={{ color: 'rgba(255,255,255,0.72)' }}>
          {eyebrow}
        </p>
        <button
          onClick={onCancel}
          className="p-1 transition-opacity hover:opacity-60"
          style={{ color: 'rgba(255,255,255,0.72)' }}
          aria-label="Close"
          data-testid={`${testId}-close`}
        >
          <X className="w-4 h-4" />
        </button>
      </div>

      <div className="px-6 sm:px-9 py-7 sm:py-8">
        <h2 className="font-heading text-2xl font-bold mb-3" style={{ color: '#2A1E5C' }}>{title}</h2>
        {lead && (
          <p className="font-body text-sm leading-relaxed mb-5" style={{ color: '#5D5A6B' }}>{lead}</p>
        )}

        {items.length > 0 && (
          <div className="p-5 mb-5" style={{ background: '#FFFFFF', border: '1px solid #E8E2D5' }}>
            <p className="font-body text-[11px] uppercase tracking-[0.2em] mb-3" style={{ color: '#8B7E6A' }}>
              What this changes
            </p>
            <ul className="space-y-2">
              {items.map((item) => (
                <li key={item} className="font-body text-sm leading-relaxed flex gap-2.5" style={{ color: '#2A1E5C' }}>
                  <span style={{ color: '#8B7E6A' }}>&middot;</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        )}

        {children}

        {note && (
          <p className="font-body text-xs leading-relaxed mb-5" style={{ color: '#8B7E6A' }}>{note}</p>
        )}

        <div className="flex flex-wrap items-center gap-3">
          <button
            onClick={onConfirm}
            disabled={busy}
            className="font-body text-sm font-semibold px-8 py-3.5 transition-opacity hover:opacity-90 disabled:opacity-50"
            style={{ background: '#2A1E5C', color: '#F2EFE7', borderRadius: 0 }}
            data-testid={`${testId}-yes-btn`}
          >
            {busy ? 'Saving…' : confirmLabel}
          </button>
          <button
            onClick={onCancel}
            className="font-body text-sm font-semibold px-7 py-3.5 transition-colors"
            style={{ background: 'transparent', color: '#5D5A6B', border: '1px solid #D9D1C2', borderRadius: 0 }}
            data-testid={`${testId}-back-btn`}
          >
            {cancelLabel}
          </button>
          {secondary && (
            <button
              onClick={secondary.onClick}
              className="font-body text-xs underline underline-offset-4 transition-opacity hover:opacity-70 ml-1"
              style={{ color: '#8B7E6A' }}
              data-testid={`${testId}-secondary-btn`}
            >
              {secondary.label}
            </button>
          )}
        </div>
      </div>
    </div>
  </div>
);
